import { Directive, ElementRef, Renderer2, HostListener, AfterViewInit } from '@angular/core';

/**
 * autoFormatExpiry
 * - Automatically inserts a slash "/" after 2 digits for "MM/YY" format.
 * - Enforces a max of 5 characters total (e.g. "12/34").
 *
 * Usage:
 *   <input autoFormatExpiry formControlName="expDate" />
 *
 * Notes:
 *  - This approach sets the caret to the end after formatting.
 *  - If user tries to edit in the middle, the cursor will jump; a more
 *    advanced approach would track selection ranges.
 */
@Directive({
  selector: '[paymentCardExpiry]',
  standalone: true
})
export class PaymentCardExpiryDirective implements AfterViewInit {

  constructor(private el: ElementRef<HTMLInputElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    // Optionally set a 'maxlength' attribute to 5 (e.g. "MM/YY")
    this.renderer.setAttribute(this.el.nativeElement, 'maxlength', '5');
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    // Remove any non-digits & slash
    let sanitized = value.replace(/[^\d/]/g, '');

    // If user typed 3 digits without slash, insert slash after 2
    // e.g. "123" -> "12/3"
    if (
      sanitized.length > 2 &&
      sanitized.charAt(2) !== '/'
    ) {
      sanitized = sanitized.slice(0, 2) + '/' + sanitized.slice(2);
    }

    // Limit to 5 characters total => "MM/YY"
    sanitized = sanitized.slice(0, 5);

    // Update input
    this.renderer.setProperty(this.el.nativeElement, 'value', sanitized);

    // Move caret to end
    const len = sanitized.length;
    this.el.nativeElement.setSelectionRange(len, len);
  }
}
